<div class="d-flex flex-column recommendation-section">
    <div class="flex-grow-1 overflow-auto pb-2">
        <div class="px-2">
            <div class="classification-search-panel border rounded p-2 mb-3 bg-white">
                <div class="mb-2">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="classificationSearchText"
                        (ngModelChange)="onClassificationSearchChange($event)"
                        placeholder="Enter classification code or description" />
                </div>
                <div *ngIf="lookupResults.length" class="lookup-results-container">
                    <div *ngFor="let lookupItem of lookupResults; trackBy: trackByLookupCode"
                        class="lookup-result-card border rounded p-2 mb-2 shadow-sm bg-white">
                        <div class="d-flex align-items-start gap-2">
                            <input type="checkbox" class="cursor-pointer form-check-input mt-1 custom-check-input"
                                [checked]="isLookupItemSelected(lookupItem.code)"
                                (change)="toggleLookupSelection(lookupItem.code, $any($event.target).checked)" />
                            <div class="flex-grow-1">
                                <div class="d-flex align-items-center">
                                    <span class="badge bg-custom-gray text-black border fw-medium">
                                        {{ lookupItem.code }}
                                    </span>
                                </div>
                                <div class="small mt-2">
                                    <p class="mb-0 text-black lh-sm ml-2">{{ lookupItem.display }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="lookupResults.length || selectedLookupCount" class="d-flex justify-content-end mt-2">
                    <button type="button" class="btn btn-dark btn-sm" [disabled]="selectedLookupCount === 0"
                        (click)="addSelectedLookupToRecommended()">
                        Add
                    </button>
                </div>
                <div *ngIf="noSearchResults" class="small text-muted mt-2">
                    No matching classifications found from API.
                </div>
            </div>
            @if(isLoading) {
            <div class="d-flex justify-content-center align-items-center h-100 text-center px-3">
                <div class="align-items-center d-flex flex-column gap-1 position-absolute top-40">
                    <p class="text-muted fw-medium">
                        Generating recommended classifications...
                    </p>

                </div>
            </div>
            } @else {
            <div *ngIf="!showAddForm && classifications.length === 0"
                class="d-flex justify-content-center align-items-center h-100 text-center px-3">
                <div class="align-items-center d-flex flex-column gap-1 position-absolute top-40">
                    <img src="{{ cvaUI_url + '/assets/icons/classification.svg' }}" alt="Classification List"
                        aria-hidden="true" class="icon-sm ico-task">

                    <p class="text-muted">
                        You don't have any classifications yet.
                    </p>

                </div>
            </div>
            <div *ngIf="classifications.length" class="list-group list-group-flush">
                <div *ngFor="let classification of classifications; let i = index; trackBy: trackByIndex">

                    <div class="border rounded p-2 mb-2 shadow-sm bg-white">
                        <div class="d-flex align-items-start gap-2">
                            @if(!classification.isSaved){
                            <input type="checkbox" (keydown.space)="toggleCheckbox(i)" (click)="toggleCheckbox(i)"
                                class="cursor-pointer form-check-input mt-1 custom-check-input" name="checkmark"
                                [checked]="classification.checked" />
                            }

                            <div class="flex-grow-1 " [ngClass]="{'ml-1-25':classification.isSaved}">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="badge bg-custom-gray text-black border fw-medium">
                                        {{ classification.code }}
                                    </span>
                                    <div class="d-flex justify-content-end gap-2">
                                        @if(classification.isSaved){
                                        <span class="badge bg-success fs-xx-small fw-medium">
                                            <i class="bi bi-check-circle-fill"></i> Classification Added
                                        </span>
                                        }
                                    </div>
                                </div>
                                <div class="small mt-2">
                                    <p class="mb-0 text-black lh-sm ml-2">{{ classification.display }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    @if(classifications.length){
    <div class="d-flex justify-content-end align-items-center flex-wrap gap-2 px-2 pt-3 pb-1">
        <button type="button" class="btn btn-dark btn-sm" [disabled]="isSubmitDisabled" (click)="postChecked()">
            Post Classification
        </button>
    </div>
    }
</div>